import { useState, useEffect } from "react";
import "../styles/GallerySerene.css";

import Img2 from "../assets/serene-images/GATE-ELONGATED.avif";
import Img3 from "../assets/serene-images/STREET-DRIVE.avif";
import Img4 from "../assets/serene-images/AMPHITHEATER-AND-SUNKEN-SEATING.avif";
import Img5 from "../assets/serene-images/BASKETBALL-COURT.avif";
import Img6 from "../assets/serene-images/BRIDGEWAY.avif";
import Img7 from "../assets/serene-images/KIDS-PLAY-AREA.avif";
import Img8 from "../assets/serene-images/SCULPTURE-WATERBODIES.avif";
import Img9 from "../assets/serene-images/VILLA-FRONT-PERGOLLA-LAWN.avif";
import Img10 from "../assets/serene-images/WATER-FEATURE.avif";

// Ensure we have exactly 9 images for the 3x3 grid
const images = [
    { src: Img2, label: "GATE ELONGATED" },
    { src: Img3, label: "STREET DRIVE" },
    { src: Img4, label: "AMPHITHEATER AND SUNKEN SEATING" },
    { src: Img5, label: "BASKETBALL COURT" },
    { src: Img6, label: "BRIDGEWAY" },
    { src: Img7, label: "KIDS PLAY AREA" },
    { src: Img8, label: "SCULPTURE WATERBODIES" },
    { src: Img9, label: "VILLA FRONT PERGOLLA LAWN" },
    { src: Img10, label: "WATER FEATURE" },
];

export default function GallerySerene() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isHovering, setIsHovering] = useState(false);
    const activeImage = images[activeIndex];

    const handlePrev = () => {
        setIsHovering(false);
        setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const handleNext = () => {
        setIsHovering(false);
        setActiveIndex((prev) => (prev + 1) % images.length);
    };

    // Auto-rotate background if not hovering
    useEffect(() => {
        if (isHovering) return; // Pause auto-play on hover

        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isHovering]);

    return (
        <section className="gallery-section" id="serene-gallery">
            {/* Full Screen Backgrounds */}
            <div className="gallery-background">
                {images.map((img, index) => (
                    <img
                        key={index}
                        src={img.src}
                        alt={img.label}
                        className={`bg-image ${index === activeIndex ? "active" : ""}`}
                    />
                ))}
                <div className="gallery-overlay"></div>
            </div>

            {/* Foreground Content */}
            <div className="gallery-content">
                <div className="gallery-grid">
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="grid-item"
                            onMouseEnter={() => {
                                setActiveIndex(index);
                                setIsHovering(true);
                            }}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <div className="grid-content text-center pertili-font">
                                <span>{img.label}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="gallery-carousel">
                    <button
                        type="button"
                        className="carousel-control prev"
                        onClick={handlePrev}
                        aria-label="Previous image"
                    >
                        &#8249;
                    </button>

                    <div className="carousel-slide">
                        <img
                            src={activeImage.src}
                            alt={activeImage.label}
                            className="carousel-image"
                        />
                        <div className="carousel-caption pertili-font">
                            {activeImage.label}
                        </div>
                    </div>

                    <button
                        type="button"
                        className="carousel-control next"
                        onClick={handleNext}
                        aria-label="Next image"
                    >
                        &#8250;
                    </button>
                </div>

                <div className="carousel-dots">
                    {images.map((img, index) => (
                        <button
                            type="button"
                            key={img.label}
                            className={`carousel-dot ${index === activeIndex ? "active" : ""}`}
                            onClick={() => {
                                setIsHovering(false);
                                setActiveIndex(index);
                            }}
                            aria-label={`Go to ${img.label}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
